<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section" v-if="$route.query.origin === 'home'">
          <breadcrumb />
        </div>

        <div class="bsd-section">
          <template v-if="canChangeDueDay">
            <div class="z-title z-title--small spacer-bottom-l" v-if="paymentMethod !== 'boleto'">
              Qual a melhor data para cobrar a mensalidade no seu cartão?
            </div>

            <div class="z-title z-title--small spacer-bottom-l" v-else>
              Qual a melhor data de vencimento para o boleto?
            </div>

            <div class="z-caption">
              Informe uma data
            </div>
            <z-dropdown placeholder="Selecione a melhor data" v-model="dueDay" :items="availableDays" />

            <button
              class="z-button z-button--primary z-button--block spacer-top-st spec-submit-button"
              :disabled="!dueDay"
              @click="updateDueDay()"
            >
              Continuar
            </button>
          </template>

          <template v-else>
            <div class="z-card">
              <div class="spacer-bottom-l">
                <z-icon
                  size="jumbo"
                  class="spacer-bottom-m"
                  color="primary"
                  :icon="['fal', 'lock-alt']"
                />
                <div class="z-title z-title--small spacer-bottom-s">
                  Atualização de data de vencimento indisponível
                </div>
                <p class="z-text">
                  Você atualizou sua data de vencimento no dia {{ currentBilling.due_day_changed_at | formatDate }}.
                  Sua próxima alteração só poderá ser efetuada a partir do dia
                  {{ currentBilling.can_change_due_day_at | formatDate }}.
                </p>
              </div>
              <router-link
                tag="button"
                :to="{ name: 'panel' }"
                class="z-button z-button--primary z-button--block"
              >
                Voltar para página inicial
              </router-link>
            </div>
          </template>

          <alert-box ref="alertBox" class="spacer-top-l" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AlertBox from 'components/zilla/alert-box';
import Breadcrumb from 'components/breadcrumb';
import ZDropdown from 'components/zilla/z-dropdown';
import BillingService from 'services/BillingService';

export default {
  components: {
    AlertBox,
    Breadcrumb,
    ZDropdown,
  },
  data() {
    return {
      dueDay: null,
    };
  },
  computed: {
    ...mapState([
      'currentBilling',
    ]),
    paymentMethod() {
      return this.currentBilling.recurrent_payment_method;
    },
    availableDays() {
      return this.currentBilling.available_due_days.map((item) => ({ value: item, label: `Todo dia ${item}` }));
    },
    canChangeDueDay() {
      return this.currentBilling.can_change_due_day;
    },
  },
  methods: {
    ...mapActions([
      'loadBillings',
    ]),
    updateDueDay() {
      this.$tracker.logEvent('[payment configuration] Selected due day', { dueDay: this.dueDay });
      this.$pageLoader.wrap(
        this.submitDueDayChanging(),
        `Salvando data de ${this.paymentMethod === 'boleto' ? 'vencimento' : 'pagamento'}`,
      );
    },
    submitDueDayChanging() {
      return BillingService.changeDueDay(this.currentBilling.id, this.dueDay)
        .then(() => {
          this.$router.push({ name: 'payment-configuration-confirmation' });
        })
        .catch(() => {
          this.$refs.alertBox.show(
            'danger', 'Erro inesperado',
            'Houve um problema ao configurar a data de pagamento.',
          );
        });
    },
  },
  mounted() {
    this.loadBillings();
  },
};
</script>
